import React from 'react';
import { updateInvestorFundQualificationMutation } from '../../../apollo';
//import InvestorQualificationForm from './InvestorQualificationForm';
import AccountForm from '../AccountForm';
import InvestorFundQualificationForm from './InvestorFundQualificationForm';

const InvestorFundQualification = (props) => (
  <AccountForm
    title='Investor Qualification'
    Form={InvestorFundQualificationForm}
    mutation={updateInvestorFundQualificationMutation}
    {...props}
  />
);
export default InvestorFundQualification;



// WEBPACK FOOTER //
// ./src/components/Account/InvestorFundQualification/index.js